import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ProgramaRepasseBndes } from "./programas-permitidos.model";
import { LimiteAdicionalTranch } from "./limite-adicional-tranch.model";

export class LimiteAdicionalProgramaBndesTranche extends BaseEntity{


    programaBndesTranche!: ProgramaRepasseBndes;
    limiteAdicionalTranche!:LimiteAdicionalTranch;
    dataDesativacao!:Date;
}
